import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useRetrievePlayerByUserId } from "../ApiProvider";
import { UserContext } from "../auth/UserProvider";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { ProfileSetup } from "./ProfileSetup";
import { dismissOnboarding, isOnboardingDismissed, } from "./onboardingDismissal";
/**
 * The invite bridge (spec Path 3a). After a new user accepts a team invite we
 * land them here to set up their player profile, then send them on to the team.
 * Returning users (who've already been through onboarding) pass straight through
 * — the invite is the persona signal, so there's no role picker.
 */
export var PostJoinProfile = function () {
    var teamId = useNumericParams().teamId;
    var navigate = useNavigate();
    var user = useContext(UserContext).user;
    var _a = useRetrievePlayerByUserId({
        userId: user === null || user === void 0 ? void 0 : user.pk,
    }), player = _a.data, isLoading = _a.isLoading, error = _a.error;
    var teamPath = "/teams/".concat(teamId, "/");
    // Already onboarded/dismissed → straight to the team, no profile prompt.
    if (user && isOnboardingDismissed(user.pk)) {
        return _jsx(Navigate, { to: teamPath, replace: true });
    }
    // Don't trap the user on a spinner if their profile fails to load — they've
    // accepted the invite, so just continue to the team.
    if (error) {
        return _jsx(Navigate, { to: teamPath, replace: true });
    }
    if (isLoading || !player || !user) {
        return _jsx(Loading, {});
    }
    var finish = function () {
        dismissOnboarding(user.pk);
        navigate(teamPath);
    };
    return _jsx(ProfileSetup, { player: player, onDone: finish });
};
